module.exports = __webpack_public_path__ + "static/media/ts3cr54.13d42ff4.png";